import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/core/base-component';
import { TokenManagerService } from 'src/app/core/services/token-manager.service';

import { Category } from 'src/app/model/category.model';
import { Store } from 'src/app/model/store.model';
import { UserCart } from 'src/app/model/user-cart.model';
import { CommonApiService } from 'src/app/shared/services/common-api.service';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss']
})
export class HeaderComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  stickyHeader: HTMLElement | undefined;
  categories: Category[] | undefined;
  searchString: string | undefined;
  cartUpdateSubjectSubscription: Subscription;
  loginSubjectSubscription: Subscription;
  userCart: UserCart;
  selectedCategory: any;
  allCategories: Category[] | undefined;
  stores: Store[] = [];
  selectedStore: Store | undefined;
  IsHidePrice:boolean;
  
  constructor(
    private router: Router,
    private elementRef: ElementRef,
    private commonApiService: CommonApiService,
    public tokenManagerService: TokenManagerService
  ) {
    super(tokenManagerService);
    this.selectedCategory = '';
    this.selectedStore = this.stores[0];
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: any): void {
    if (window.scrollY > 150) {
      this.stickyHeader?.classList?.add('fixed');
    } else {
      this.stickyHeader?.classList?.remove('fixed');
    }
  }

  ngOnInit(): void {
    this.getCategories();
    this.getAllCategories();
    this.getStores();

    this.IsHidePrice = this.tokenManagerService.appConfiguration.IsHidePrice;

    this.cartUpdateSubjectSubscription = this.commonApiService.cartUpdateSubject.subscribe(
      (result) => {
        this.getUserCart();
      });

    this.loginSubjectSubscription = this.tokenManagerService.loginSubject.subscribe(
      (result) => {
        if (result) {
          this.user = this.tokenManagerService.userDetail;
        }
      });

    this.getUserCart();
  }

  ngAfterViewInit(): void {
    this.stickyHeader = this.elementRef.nativeElement.getElementsByClassName('sticky-header')[0];
  }

  getCategories(): void {
    this.commonApiService.getCategories().subscribe(
      (response: Category[]) => {
        this.categories = response;
      },
      (error) => {
      });
  }

  searchTerm(): void {
    if (this.selectedCategory.isParent || !this.selectedCategory.CategoryEncryptedId) {
      this.router.navigate(['/search',
        this.selectedCategory.CategoryName
      ], {
        queryParams: {
          term: this.searchString,
          id: this.selectedCategory.CategoryEncryptedId,
          type: 'category',
          name: this.selectedCategory.CategoryName
        }
      });
    } else if (this.selectedCategory) {
      this.router.navigate(['/search',
        this.selectedCategory.CategoryName
      ], {
        queryParams: {
          id: this.selectedCategory.CategoryEncryptedId,
          type: 'subcategory',
          name: this.selectedCategory.CategoryName
        }
      });
    } else {
      this.router.navigate(['/search',
        this.selectedCategory.CategoryName
      ], {
        queryParams: {
          term: this.searchString,
          id: this.selectedCategory.CategoryEncryptedId,
          type: 'subcategory',
          name: this.selectedCategory.CategoryName
        }
      });
    }
  }

  navigateOnCategory(category: Category): void {
    this.categories?.forEach(item => item.isActive = false);
    category.isActive = true;
    this.router.navigate(['/search', category.CategoryName,
    ], { queryParams: { name: category.CategoryName, id: category.CategoryEncryptedId, type: 'category' } });
  }

  getUserCart(): void {
    this.commonApiService.getUserCart().subscribe(
      (response: UserCart) => {
        this.userCart = response;
      }, (error) => {

      });
  }

  signOut(): void {
    this.commonApiService.signOut().subscribe(
      (response) => {
        if (response) {
          this.tokenManagerService.clearLocalStorage();
          this.tokenManagerService.setToken(response.Token);
          this.tokenManagerService.storeDetails = response;
          this.tokenManagerService.loginSubject.next(true);
          this.router.navigate(['/']);
          this.getUserCart();
        }
      });
  }

  getAllCategories(): void {
    this.commonApiService.getAllCategories().subscribe(
      (response: Category[]) => {
        this.allCategories = response;
        this.allCategories.unshift({ CategoryEncryptedId: '', CategoryName: 'All Categories' });
        this.selectedCategory = { CategoryEncryptedId: '', CategoryName: 'All Categories' };
      },
      (error) => {
      });
  }

  changeStore(store: Store): void {
    location.href = `?id=${store.StoreId}`;
  }

  getStores(): void {
    this.commonApiService.getStores().subscribe(
      (response) => {
        this.stores = response;
      },
      (error) => {
      });
  }

  ngOnDestroy(): void {
    this.cartUpdateSubjectSubscription?.unsubscribe();
    this.loginSubjectSubscription?.unsubscribe();
  }

}
